export default __webpack_public_path__ + "static/dai-849478a756d546e306e87e72a46644e2.png";